import React, { useState } from "react";
import SwoodleLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";
import passwordIcon from "../../../Assets/Icons/passwordIcon.svg";
import TextInput from "../SignUp/TextInput";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { resetPasswordSchema } from "../../../utils/validationSchemas";
import { resetPassword } from "../../../services/authService";
import PrimaryButton from "../PrimaryButton";
import SwoodleFooter from "../SwoodleFooter";
import LoginHeader from "../LoginHeader";
import MultipleAccountsModal from "./MultipleAccountsModal";

const responsiveShellStyle = {
  width: "100%",
  maxWidth: "min(1920px, calc(100vw - 2vw))",
  margin: "0 auto",
};

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const otpData = useSelector((state) => state?.authReducer?.otpToken);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accountConfirmation, setAccountConfirmation] = useState(null);

  const togglePassword = () => setShowPassword(!showPassword);

  const toggleConfirmPassword = () =>
    setConfirmShowPassword(!showConfirmPassword);

  const submitPasswordReset = async (password, confirmAllAccounts = false) => {
    setLoading(true);
    try {
      const resetPromise = await dispatch(
        resetPassword({
          token: otpData,
          password,
          ...(confirmAllAccounts ? { confirmAllAccounts: true } : {}),
        }),
      ).unwrap();

      if (resetPromise?.requiresAccountConfirmation) {
        setAccountConfirmation(resetPromise.data);
        return;
      }

      if (resetPromise?.success === true) {
        navigate("/");
      } else {
        navigate("/forget-password");
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: async (values) => {
      await submitPasswordReset(values.password);
    },
  });

  const { password, confirmPassword } = formik.values;

  const { handleChange, handleBlur, handleSubmit, errors, touched } = formik;

  return (
    <>
    <form onSubmit={handleSubmit}>
      <div className="min-h-screen bg-white flex flex-col">
        <div className="w-full px-6 py-4">
          <div style={responsiveShellStyle}>
            <LoginHeader />
          </div>
        </div>

        <div className="flex-1 w-full flex flex-col items-center">
          <div className="w-full max-w-[640px] px-12 mt-10">
            <h2 className="text-center text-[26px] md:text-[30px] font-[700] font-poppins text-[#303030]">Enter New Password</h2>
            <p className="text-center text-[#8C8C8C] mt-0 text-[14px] md:text-[15px]">Set a new password for your account.</p>

            <div className="mt-8 space-y-4 flex flex-col items-center">
              <div className="w-[360px] sm:w-[420px] md:w-[460px]">
                <TextInput
                  type={showPassword ? "text" : "password"}
                  name={"password"}
                  value={password}
                  placeholder={"Enter Password"}
                  inputClass={"h-full bg-[#F2F4F5] border border-[#EFF2F5] rounded-[12px] px-4 text-[16px] font-poppins font-[500] placeholder:text-[#8C8C8C]"}
                  innerDivClass={"h-[56px] w-full items-center"}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors.password}
                  touched={touched.password}
                  showPassword={showPassword}
                  togglePassword={togglePassword}
                  autoComplete={"new-password"}
                />
              </div>

              <div className="w-[360px] sm:w-[420px] md:w-[460px]">
                <TextInput
                  type={showConfirmPassword ? "text" : "password"}
                  name={"confirmPassword"}
                  value={confirmPassword}
                  placeholder={"Enter Confirm Password"}
                  inputClass={"h-full bg-[#F2F4F5] border border-[#EFF2F5] rounded-[12px] px-4 text-[16px] font-poppins font-[500] placeholder:text-[#8C8C8C]"}
                  innerDivClass={"h-[56px] w-full items-center"}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors.confirmPassword}
                  touched={touched.confirmPassword}
                  showPassword={showConfirmPassword}
                  togglePassword={toggleConfirmPassword}
                />
              </div>

              <div className="pt-1" />
            </div>

            <div className="mt-6 flex justify-center">
              <PrimaryButton
                type="submit"
                className="w-[360px] sm:w-[420px] md:w-[460px] h-[60px] rounded-[8px] font-[600]"
                label="Set New Password"
                loading={loading}
              />
            </div>
          </div>
        </div>

        <div className="mt-16">
          <SwoodleFooter containerStyle={responsiveShellStyle} enableEntranceAnimation={true} />
        </div>
      </div>
    </form>
    {accountConfirmation && (
      <MultipleAccountsModal
        email={accountConfirmation.email}
        accountCount={accountConfirmation.accountCount}
        roles={accountConfirmation.roles}
        loading={loading}
        onCancel={() => setAccountConfirmation(null)}
        onContinue={() =>
          submitPasswordReset(formik.values.password, true)
        }
      />
    )}
    </>
  );
};

export default ResetPassword;
